export default __webpack_public_path__ + "static/media/dennisAndCo.4fc7238d.png";